module.exports = wp["compose"];